import { API, authClient } from "../index";

export const getOpenAIConfig = (accessToken) => {
  return authClient(accessToken).get(`${API}/config/openai`);
};

export const updateOpenAIConfig = (openAIConfig, accessToken) => {
  return authClient(accessToken).put(`${API}/config/openai`, openAIConfig);
};

export const updateOpenAIAdminKey = (data, accessToken) => {
  return authClient(accessToken).put(`${API}/config/openai/admin-key`, data);
};

export const getOpenAIModels = (openAIConfig, accessToken) => {
  return authClient(accessToken).post(`${API}/config/openai/models`, openAIConfig);
};
